

export function humanized(timestamp, lang) {
    let timeString = parseInt(timestamp) * 1000;
    return timestampToHumanizedString(timeString, lang);
}

export function timestampToHumanizedString(timestamp, lang){

    const localeMap = {
        'gb': 'en-GB',
        'us': 'en-US',
        'br': 'pt-BR',
        'mx': 'es-MX',
        'cl': 'es-CL',
        'py': 'es-PY',
        'es': 'es-ES',
        'ca': 'ca',
        'fr': 'fr-FR',
        'pt': 'pt-PT',
        'it': 'it-IT',
        'de': 'de-DE',
        'he': 'he-IL'
    };
    
    const intlLocale = localeMap[lang] || lang || navigator.language;
  
    // Get the amount of seconds between the given date and now
    const deltaSeconds = Math.round((timestamp - Date.now()) / 1000);
  
    // Array representing one minute, hour, day, week, month, year, in seconds
    const cutoffs = [60, 3600, 86400, 86400 * 7, 86400 * 30, 86400 * 365, Infinity];
  
    // Array equivalent to the above but in the string representation of the units
    const timeUnits = ["second", "minute", "hour", "day", "week", "month", "year"];
  
    // Grab the ideal cutoff unit
    const idealUnitIndex = cutoffs.findIndex(cutoff => cutoff > Math.abs(deltaSeconds));
  
    // Get the divisor to divide from the seconds. E.g. if our unit is "day" our divisor
    // is one day in seconds, so we can divide our seconds by this to get the # of days
    const divisor = idealUnitIndex ? cutoffs[idealUnitIndex - 1] : 1;
  
    // Intl.RelativeTimeFormat do its magic
    const rtf = new Intl.RelativeTimeFormat(intlLocale, { numeric: "auto" });
    return rtf.format(Math.floor(deltaSeconds / divisor), timeUnits[idealUnitIndex]);
}

export function timestampToDateTimeTwoDigit(timestamp) {
    if (!timestamp || parseInt(timestamp) <= 0) return '';

    const date = new Date(parseInt(timestamp) * 1000);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
}
